import { useLocation } from "react-router-dom";
import { Row, Button, Col, Tabs } from "antd";
import { useEffect, useState } from "react";
import moment from "moment-timezone";

import { GET } from "../../../providers/useAxiosQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faList, faPlus } from "@fortawesome/pro-regular-svg-icons";

import PageEntranceExamCalendar from "./PageEntranceExamCalendar";
import ModalFormEntranceExamSchedule from "../PageEntranceExam/components/ModalFormEntranceExamSchedule";
import TableEntranceExam from "./components/TableEntranceExam";

export default function PageEntranceExam() {
	const location = useLocation();

	moment.tz.setDefault("Asia/Manila");

	const [
		toggleModalFormEntranceExamSchedule,
		setToggleModalFormEntranceExamSchedule,
	] = useState({
		open: false,
		data: null,
	});

	moment.tz.setDefault("Asia/Manila");

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at",
		sort_order: "desc",
		from: location.pathname.includes("entrance-exam") ? "entrance-exam" : "",
		isTrash: 0,
	});

	const [activeTab, setActiveTab] = useState("1");

	const {
		data: dataExamScheduleSource,
		refetch: refetchSource,
		isLoading: isLoadingExamSchedule,
		isFetching: isFetching,
	} = GET(
		`api/exam_schedule?${new URLSearchParams(tableFilter)}`,
		"exam_schedule_list"
	);

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	useEffect(() => {
		setTableFilter({
			page: 1,
			page_size: 50,
			search: "",
			sort_field: "created_at",
			sort_order: "desc",
			status: ["Active"],
			from: location.pathname.includes("entrance-exam") ? "entrance-exam" : "",
			isTrash: 0,
		});

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return (
		<>
			{location.pathname === "/entrance-exam/schedule" ? (
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="primary"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={() =>
							setToggleModalFormEntranceExamSchedule({
								open: true,
							})
						}
						name="btn_add"
					>
						Add Exam Schedule
					</Button>
				</Col>
			) : null}

			<Tabs
				className="TABS"
				defaultActiveKey="1"
				indicator={{
					size: (origin) => origin - 25,
					align: "end",
				}}
				onChange={(e) => {
					if (!isLoadingExamSchedule || !isFetching) setActiveTab(e);
				}}
				items={[
					{
						icon: <FontAwesomeIcon icon={faList} />,
						label: "Exam Schedule List View",
						key: "1",
						children: (
							<Row gutter={[12, 12]}>
								<Col xs={24} sm={24} md={24}>
									<TableEntranceExam
										dataSource={dataExamScheduleSource}
										tableFilter={tableFilter}
										setTableFilter={setTableFilter}
									/>
								</Col>
							</Row>
						),
					},
					{
						icon: <FontAwesomeIcon icon={faCalendar} />,
						label: "Exam Schedule Calendar View",
						className: "tab-item-school-attended-info",
						key: "2",
						disabled:
							!dataExamScheduleSource || dataExamScheduleSource.length === 0,
						children: (
							<PageEntranceExamCalendar
								dataSource={dataExamScheduleSource}
								location={location}
								refetchSource={refetchSource}
							/>
						),
					},
				]}
			/>

			<ModalFormEntranceExamSchedule
				toggleModalFormEntranceExamSchedule={
					toggleModalFormEntranceExamSchedule
				}
				setToggleModalFormEntranceExamSchedule={
					setToggleModalFormEntranceExamSchedule
				}
			/>
		</>
	);
}
